module.exports = __webpack_public_path__ + "img/end_setup.562f33fc.png";